module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('bar-chart', {
    attrs: {
      "isHorizontal": _vm.isHorizontal,
      "series": _vm.empleadosSeries,
      "categories": _vm.areas,
      "yAxisTitle": _vm.isHorizontal ? 'Areas' : 'Empleados',
      "tooltipFormatter": _vm.tooltipFormatter,
      "xAxisTitle": !_vm.isHorizontal ? 'Areas' : 'Empleados',
      "title": "Cantidad de Empleados por Area",
      "showLegend": false,
      "showXlabels": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6fb64f0","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/c_kpi_empleado_por_areas.vue
// module id = 877
// module chunks = 0